import React from 'react';

import styles from './AddressDetailsOrder.module.scss';
import addressIcon from "../../constants/images/detailsOrder/address.svg";
import dateIcon from "../../constants/images/detailsOrder/date.svg";
import card from "../../constants/images/detailsOrder/credit-card.svg";

const AddressDetailsOrder = ({address, date, time, price}) => {
    const handleFormatTime = () => {
        const formattedTime = time.split(':');
        const hours = formattedTime[0];
        const minutes = formattedTime[1];

        return `${hours}:${minutes}`;
    }

    return (
        <div className={styles.addressDetailsOrder}>
            <div className={styles.addressDetailsOrder_blockContainer}>
                <div className={styles.addressDetailsOrder_blockContainer_block}>
                    <img src={addressIcon} alt="address icon"/>
                    <p className={styles.subtitle}>Адреса</p>
                </div>
                <p className={styles.userInfo}>{address}</p>
            </div>

            <div className={styles.addressDetailsOrder_blockContainer}>
                <div className={styles.addressDetailsOrder_blockContainer_block}>
                    <img src={dateIcon} alt="date icon"/>
                    <p className={styles.subtitle}>Дата та час</p>
                </div>
                <div>
                    <p className={styles.userInfo}>{date}</p>
                    <p className={styles.userInfo}>{handleFormatTime()}</p>
                </div>
            </div>

            {!!price && <div className={styles.addressDetailsOrder_blockContainer}>
                <div className={styles.addressDetailsOrder_blockContainer_block}>
                    <img src={card} alt="card icon"/>
                    <p className={styles.subtitle}>Оплата</p>
                </div>
                <p className={styles.userInfo}> ₴ {price} </p>
            </div>}
        </div>
    );
};

export default AddressDetailsOrder;
